import React from 'react'
import Button from 'client/shared/blocks/button'
import Spacer from 'client/shared/blocks/spacer'
import LoginButton from 'client/shared/blocks/login-button'
import HeaderBox from 'client/shared/boxes/header-box'
import { Heading } from 'client/shared/blocks/heading/heading'
import Carousel from 'client/shared/blocks/carousel/carousel'

import './codigo-layout.styl'

type Props = {
  auth: boolean
  handleForm: (e: React.SyntheticEvent<HTMLFormElement>) => void
  handleInput: (e: React.SyntheticEvent<HTMLInputElement>) => void
  isDesktop: boolean
  code: {
    codeValue: string
    autocomplete: boolean
    loading: boolean
    error: string | null | undefined
  }
  locale: string
}

const CodigoCaption = (): JSX.Element => (
  <>
    <p className="codigo-caption">
      Bookmate es una app para leer y escuchar libros, audiolibros y comics de
      manera ilimitada con una sola suscripción.
    </p>
    <p className="codigo-caption">
      Activa el siguiente código para aprovechar la oferta:  
    </p>
  </>
)

export class CodigoLayout extends React.Component<Props> {
  render(): JSX.Element {
    const { auth, code, handleForm, handleInput, isDesktop } = this.props
    const { codeValue, autocomplete, error, loading } = code

    const enabled = typeof codeValue === 'string' && codeValue?.trim()

    const SubmitForm = (
      <form onSubmit={handleForm}>
        <input
          className="codigo-code-input"
          placeholder="XXXXXXXX"
          type="text"
          value={codeValue}
          disabled={autocomplete}
          onChange={handleInput}
        />
        {error && (
          <>
            <Spacer />
            <div className="codigo-code-input_error">{error}</div>
          </>
        )}
        <Spacer />
        {auth ? (
          <>
            <Button
              className="codigo-action-button"
              type="inline"
              loading={loading}
              disabled={!enabled}
              aria-label="Activar"
            >
              Activar
            </Button>
            <Spacer />
          </>
        ) : (
          <>
            <LoginButton message="Activar" type="button" />
            <p className="codigo-subheader">Regístrate o inicia sesión.</p>
          </>
        )}
      </form>
    )

    return (
      <div className="codigo-layout">
        <HeaderBox />
        <div className="codigo-lead-in">
          <div className="codigo-column">
            <Heading kind="graphik" className="codigo-heading">
              Con Bookmate,
              <br /> vas a querer leer más
            </Heading>
            <Spacer size={32} />
            <CodigoCaption />
            <Spacer size={24} />
            {SubmitForm}
            {!isDesktop && (
              <>
                <Spacer size={80} />
                <div className="codigo-decor" />
              </>
            )}
          </div>
        </div>
        {isDesktop ? (
          <div className="codigo-benefits">
            <div className="codigo-benefits-pair">
              <div className="codigo-benefit-cover" />
              <div className="codigo-benefit">
                <p className="codigo-benefit__lead-in">
                  {CODIOGO_BENEFITS[0].leadIn}
                </p>
                <p className="codigo-benefit__desc">
                  {CODIOGO_BENEFITS[0].description}
                </p>
              </div>
            </div>
            <div className="codigo-benefits-pair">
              <div className="codigo-benefit">
                <p className="codigo-benefit__lead-in">
                  {CODIOGO_BENEFITS[1].leadIn}
                </p>
                <p className="codigo-benefit__desc">
                  {CODIOGO_BENEFITS[1].description}
                </p>
              </div>
              <div className="codigo-benefit-cover" />
            </div>
            <div className="codigo-benefits-pair">
              <div className="codigo-benefit-cover" />
              <div className="codigo-benefit">
                <p className="codigo-benefit__lead-in">
                  {CODIOGO_BENEFITS[2].leadIn}
                </p>
                <p className="codigo-benefit__desc">
                  {CODIOGO_BENEFITS[2].description}
                </p>
              </div>
            </div>
            <div className="codigo-benefits-pair">
              <div className="codigo-benefit">
                <p className="codigo-benefit__lead-in">
                  {CODIOGO_BENEFITS[3].leadIn}
                </p>
                <p className="codigo-benefit__desc">
                  {CODIOGO_BENEFITS[3].description}
                </p>
              </div>
              <div className="codigo-benefit-cover" />
            </div>
          </div>
        ) : (
          <Carousel infinite={false} className="codigo-carousel" contain>
            <div className="codigo-benefits-pair">
              <div className="codigo-benefit-cover" />
              <div className="codigo-benefit">
                <p className="codigo-benefit__lead-in">
                  {CODIOGO_BENEFITS[0].leadIn}
                </p>
                <p className="codigo-benefit__desc">
                  {CODIOGO_BENEFITS[0].description}
                </p>
              </div>
            </div>
            <div className="codigo-benefits-pair">
              <div className="codigo-benefit-cover" />
              <div className="codigo-benefit">
                <p className="codigo-benefit__lead-in">
                  {CODIOGO_BENEFITS[1].leadIn}
                </p>
                <p className="codigo-benefit__desc">
                  {CODIOGO_BENEFITS[1].description}
                </p>
              </div>
            </div>
            <div className="codigo-benefits-pair">
              <div className="codigo-benefit-cover" />
              <div className="codigo-benefit">
                <p className="codigo-benefit__lead-in">
                  {CODIOGO_BENEFITS[2].leadIn}
                </p>
                <p className="codigo-benefit__desc">
                  {CODIOGO_BENEFITS[2].description}
                </p>
              </div>
            </div>
            <div className="codigo-benefits-pair">
              <div className="codigo-benefit-cover" />
              <div className="codigo-benefit">
                <p className="codigo-benefit__lead-in">
                  {CODIOGO_BENEFITS[3].leadIn}
                </p>
                <p className="codigo-benefit__desc">
                  {CODIOGO_BENEFITS[3].description}
                </p>
              </div>
            </div>
          </Carousel>
        )}
        <div className="codigo-footer">
          <Heading kind="kazimir" rank={2}>
            ¡Regístrate y disfruta de un mes gratis!
          </Heading>
          <Spacer size={48} />
          {SubmitForm}
        </div>
      </div>
    )
  }
}

const CODIOGO_BENEFITS = [
  {
    leadIn: 'Explora un catalógo infinito',
    description:
      'Descubre nuestro inmenso catálogo con millones de libros, audiolibros y novelas gráficas en 19 idiomas. Encuentra libros de editoriales independientes de todo el continente latinoamericano.',
  },
  {
    leadIn: 'Lee donde quieras y cuando quieras',
    description:
      'Disfruta de Bookmate en tres dispositivos móviles a la vez hasta sin conexión a Internet.',
  },
  {
    leadIn: 'Personaliza tu lectura',
    description:
      'Cambia el color de tu pantalla, modifica el tamaño de la fuente, decide hacia dónde deslizar tu siguiente página, modifica la velocidad del reproductor de audio.',
  },
  {
    leadIn: 'Encuentra tu siguiente lectura',
    description:
      'Encuentra libros que te gusten gracias a nuestro algoritmo y a las estanterías curadas a mano por nuestro equipo editorial y otros lectores.',
  },
]
